export default "__VITE_ASSET___nSg8jke__"